import { ApiResponse, apiClient } from './apiClient';

export interface EntraGroup {
  id: string;
  displayName: string;
  description: string;
  type: 'group' | 'user';  // Changed to match backend response
  subType?: 'Security' | 'Microsoft 365';  // Group classification detail
  groupTypes: string[];
  securityEnabled?: boolean;  // For backward compatibility
  mailEnabled?: boolean;  // For backward compatibility
  isInUse?: boolean;  // Whether the group is already in use (only present in search results)
}

export interface GroupSearchResponse {
  groups: EntraGroup[];
  total: number;
  query: string;
}

class GroupService {
  /**
   * Search for Entra ID groups by display name
   * @param query Search query (minimum 2 characters)
   * @returns Promise with group search results
   */
  async searchGroups(query: string): Promise<GroupSearchResponse> {
    if (!query || query.trim().length < 2) {
      return {
        groups: [],
        total: 0,
        query: query.trim()
      };
    }

    try {
      const response = await apiClient.get<GroupSearchResponse>(
        `/teams/groups/search?q=${encodeURIComponent(query.trim())}`
      );
      
      console.log('Raw API response:', response);
      console.log('Response data:', response.data);
      
      // ApiResponse wraps the data in a 'data' property
      // Backend returns: { success: true, data: { groups: [...], total: n, query: q } }
      const result = response.data || {
        groups: [],
        total: 0,
        query: query.trim()
      };
      
      console.log('Returning groups:', result.groups);
      return result;
    } catch (error) {
      console.error('Failed to search groups:', error);
      throw new Error(error instanceof Error ? error.message : 'Failed to search groups');
    }
  }
}

export const groupService = new GroupService();
export default groupService;